module.exports = __webpack_public_path__ + "img/kutip.c0dbf5d1.svg";